import React, { useEffect } from 'react';

import useMyRewardsControllerModel from './useMyRewardsControllerModel';
import useMyRewardsControllerLogic from './useMyRewardsControllerLogic';

import MyRewards from '../../../atomic/organism/MyRewards';
import { ComponentStatus } from '../../../interfaces/component';
import { useLocation } from 'react-router-dom';
import { userActivitiesStore } from '../../../stores/userActivitiesStore';

const MyRewardsController = () => {
  const {
    models: { rewardsHistory, assemblyCurrency, myRewardsData },
    metadata: { isLoading, isError },
    actions: { resendEmailForMyRewards },
  } = useMyRewardsControllerModel();
  const { pathname, search } = useLocation();

  const {
    data: { rewards, isRedemptionDetailsLoading, trackingLink, shippingStatus },
    operations: { onButtonClick },
  } = useMyRewardsControllerLogic(myRewardsData, resendEmailForMyRewards);

  const { upsertUserActivity } = userActivitiesStore.getState();

  useEffect(() => {
    upsertUserActivity({
      visitCount: 1,
      type: 'rewards',
      url: `${pathname}${search}`,
      lastVisitedAt: new Date().toISOString(),
      pageTitle: `Rewards - My redeemed rewards`,
      pageDescription: `Browse your rewards catalog and redeem your points for rewards`,
    });
  }, [pathname, search, upsertUserActivity]);

  if (isError) {
    return <div>Error</div>;
  }

  if (isLoading) {
    return <MyRewards status={ComponentStatus.LOADING} />;
  }

  if (rewards && rewardsHistory && assemblyCurrency) {
    return (
      <MyRewards
        status={ComponentStatus.LOADED}
        assemblyCurrency={assemblyCurrency}
        rewards={rewards}
        rewardsHistory={rewardsHistory}
        onButtonClick={onButtonClick}
        isRedemptionDetailsLoading={isRedemptionDetailsLoading}
        trackingLink={trackingLink}
        shippingStatus={shippingStatus}
      />
    );
  }

  if (rewards?.length === 0 && assemblyCurrency) {
    return (
      <MyRewards
        status={ComponentStatus.EMPTY}
        assemblyCurrency={assemblyCurrency}
      />
    );
  }

  return null;
};

export default MyRewardsController;
